enum BarcodeSwissQrCodeFormDialogFields {
	VERSION = "version",
	CODING_TYPE = "coding_type",
	ACCOUNT = "account",
	CREDITOR_NAME = "creditor_name",
	CREDITOR_TYPE = "creditor_type",
	CREDITOR_ADDRESSLINE1 = "creditor_addressLine1",
	CREDITOR_ADDRESSLINE2 = "creditor_addressLine2",
	CREDITOR_STREET = "creditor_street",
	CREDITOR_HOUSE_NUMBER = "creditor_house_number",
	CREDITOR_POSTAL_CODE = "creditor_postal_code",
	CREDITOR_LOCATION = "creditor_location",
	CREDITOR_COUNTRY_CODE = "creditor_country_code",
	DEBTOR_NAME = "debtor_name",
	DEBTOR_TYPE = "debtor_type",
	DEBTOR_ADDRESSLINE1 = "debtor_addressLine1",
	DEBTOR_ADDRESSLINE2 = "debtor_addressLine2",
	DEBTOR_STREET = "debtor_street",
	DEBTOR_HOUSE_NUMBER = "debtor_house_number",
	DEBTOR_POSTAL_CODE = "debtor_postal_code",
	DEBTOR_LOCATION = "debtor_location",
	DEBTOR_COUNTRY_CODE = "debtor_country_code",
	AMOUNT = "amount",
	CURRENCY = "currency",
	REFERENCE_TYPE = "reference_type",
	REFERENCE = "reference",
	UNSTRUCTURED_MESSAGE = "unstructured_message",
	CONTENT = "content"
}

export default BarcodeSwissQrCodeFormDialogFields;